const selectors = {
  customerAddresses: '[data-customer-addresses]',
  addressCountrySelect: '[data-address-country-select]',
  addressContainer: '[data-address]',
  toggleAddressButton: 'button[aria-expanded]',
  cancelAddressButton: 'button[type="reset"]',
  deleteAddressButton: 'button[data-confirm-message]',
};

const attributes = {
  expanded: 'aria-expanded',
  confirmMessage: 'data-confirm-message',
};

class PasswordRecovery {
  constructor() {
    this.loginForm = document.querySelector('#js-login-form');
    this.recoverForm = document.querySelector('#js-recover-password');
    this.showRecoverLink = document.querySelector('a[href="#recover"]');
    this.hideRecoverButton = document.querySelector('#js-hide-recover-form');

    if (!this.loginForm || !this.recoverForm) return;

    this._setupEventListeners();
    this._checkHash();
  }

  _setupEventListeners() {
    if (this.showRecoverLink) {
      this.showRecoverLink.addEventListener('click', (e) => {
        e.preventDefault();
        this._showRecoverForm();
      });
    }

    if (this.hideRecoverButton) {
      this.hideRecoverButton.addEventListener('click', (e) => {
        e.preventDefault();
        this._hideRecoverForm();
      });
    }
  }

  _checkHash() {
    // Check if URL has #recover hash to show recover form on page load
    if (window.location.hash === '#recover') {
      this._showRecoverForm();
    }
  }

  _showRecoverForm() {
    this.loginForm.style.display = 'none';
    this.recoverForm.style.display = 'block';
    window.location.hash = '#recover';
  }

  _hideRecoverForm() {
    this.recoverForm.style.display = 'none';
    this.loginForm.style.display = 'block';
    window.location.hash = '';
  }
}

class CustomerAddresses {
  constructor() {
    this.elements = this._getElements();
    if (Object.keys(this.elements).length === 0) return;
    this._setupCountries();
    this._setupEventListeners();
  }

  _getElements() {
    const container = document.querySelector(selectors.customerAddresses);
    return container
      ? {
          container,
          addressContainer: container.querySelector(selectors.addressContainer),
          toggleButtons: container.querySelectorAll(selectors.toggleAddressButton),
          cancelButtons: container.querySelectorAll(selectors.cancelAddressButton),
          deleteButtons: container.querySelectorAll(selectors.deleteAddressButton),
          countrySelects: container.querySelectorAll(selectors.addressCountrySelect),
        }
      : {};
  }

  _setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
        hideElement: 'AddressProvinceContainerNew',
      });
      this.elements.countrySelects.forEach((select) => {
        const formId = select.dataset.formId;
        // eslint-disable-next-line no-new
        new Shopify.CountryProvinceSelector(`AddressCountry_${formId}`, `AddressProvince_${formId}`, {
          hideElement: `AddressProvinceContainer_${formId}`,
        });
      });
    }
  }

  _setupEventListeners() {
    this.elements.toggleButtons.forEach((element) => {
      element.addEventListener('click', this._handleAddEditButtonClick);
    });
    this.elements.cancelButtons.forEach((element) => {
      element.addEventListener('click', this._handleCancelButtonClick);
    });
    this.elements.deleteButtons.forEach((element) => {
      element.addEventListener('click', this._handleDeleteButtonClick);
    });
  }

  _toggleExpanded(target) {
    const isExpanded = target.getAttribute(attributes.expanded) === 'false';
    target.setAttribute(attributes.expanded, isExpanded.toString());
    
    // Toggle the form visibility using aria-controls
    const formId = target.getAttribute('aria-controls');
    if (formId) {
      const form = document.getElementById(formId);
      if (form) {
        form.style.display = isExpanded ? 'block' : 'none';
      }
    }
  }

  _handleAddEditButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget);
  };

  _handleCancelButtonClick = ({ currentTarget }) => {
    this._toggleExpanded(currentTarget.closest(selectors.addressContainer).querySelector(`[${attributes.expanded}]`));
  };

  _handleDeleteButtonClick = ({ currentTarget }) => {
    // eslint-disable-next-line no-alert
    if (confirm(currentTarget.getAttribute(attributes.confirmMessage))) {
      Shopify.postLink(currentTarget.dataset.target, {
        parameters: { _method: 'delete' },
      });
    }
  };
}

// Initialize password recovery functionality
document.addEventListener('DOMContentLoaded', () => {
  new PasswordRecovery();
  new CustomerAddresses();
});
